/**
 * Shared mutability heuristics for checkpoint capture and jump resolution.
 * Keep this centralized so flowchart, host replay, and agent runtime stay aligned.
 */

const NON_MUTATING_TOOL_PREFIXES = ['read', 'search', 'retrieve', 'get', 'list', 'fetch'];
const NON_MUTATING_TOOL_NAMES = new Set([
    'submitresults',
    'agent_test',
    'userinterview',
    'user_message',
]);

export function isMutatingToolName(toolName?: string): boolean {
    const normalized = (toolName || '').trim().toLowerCase();
    if (!normalized) {
        return false;
    }
    if (NON_MUTATING_TOOL_NAMES.has(normalized)) {
        return false;
    }
    return !NON_MUTATING_TOOL_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}
